import { render, staticRenderFns } from "./deanAdminDeploy.vue?vue&type=template&id=21bc4903&scoped=true"
import script from "./deanAdminDeploy.vue?vue&type=script&lang=js"
export * from "./deanAdminDeploy.vue?vue&type=script&lang=js"
import style0 from "./deanAdminDeploy.vue?vue&type=style&index=0&id=21bc4903&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21bc4903",
  null
  
)

export default component.exports